// extracted by mini-css-extract-plugin
module.exports = {"InputBox":"_2Blb9","searchBtn":"_6WOTF","SearchBox":"_2Xdiw","SearchBox_active":"_3TGQe"};